import { render, staticRenderFns } from "./TblFlows.vue?vue&type=template&id=4345e84c&scoped=true&"
import script from "./TblFlows.vue?vue&type=script&lang=js&"
export * from "./TblFlows.vue?vue&type=script&lang=js&"
import style0 from "./TblFlows.vue?vue&type=style&index=0&id=4345e84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345e84c",
  null
  
)

export default component.exports